import { Link } from 'react-router-dom';
import { latestVideos } from '@/mocks/videos';

export default function LatestSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">第一时间获取最新上架的视频内容</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            更多新片 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div data-product-shop className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {latestVideos.slice(0, 8).map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 bg-background-950/75 backdrop-blur-sm text-background-50 text-[10px] px-1.5 py-0.5 rounded">
                  {video.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[11px] text-foreground-400">{video.views} 次观看</span>
                  <span className="text-[11px] text-foreground-400">{video.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}